// extracted by mini-css-extract-plugin
module.exports = {"data-block-root":"data-block-root-3PFsg","bgimg":"bgimg-3j__f","icon":"icon-apHN5","message":"message-16oCs","count":"count-3COBJ","tip":"tip-1lk6b"};